:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._publishPipeline_y2fo8_7 ._wrapper_nonDevMode_y2fo8_7 {
  margin-top: 12px; }
  ._publishPipeline_y2fo8_7 ._wrapper_nonDevMode_y2fo8_7 g {
    fill: #116dff; }
  ._publishPipeline_y2fo8_7 ._wrapper_nonDevMode_y2fo8_7 .control-text-button {
    vertical-align: text-bottom; }
  ._publishPipeline_y2fo8_7 ._wrapper_nonDevMode_y2fo8_7 .control-text {
    vertical-align: middle; }
  ._publishPipeline_y2fo8_7 ._wrapper_nonDevMode_y2fo8_7 ._bulletWrapper_y2fo8_15 {
    margin-bottom: 24px; }
    ._publishPipeline_y2fo8_7 ._wrapper_nonDevMode_y2fo8_7 ._bulletWrapper_y2fo8_15 ._bullet_y2fo8_15 {
      display: flex; }
      ._publishPipeline_y2fo8_7 ._wrapper_nonDevMode_y2fo8_7 ._bulletWrapper_y2fo8_15 ._bullet_y2fo8_15 .tooltip-on-ellipsis-content.singleLine {
        margin-left: 7px; }

._publishPipeline_y2fo8_7 ._devPanelWrapper_y2fo8_22 .control-base-modal-body {
  padding-bottom: 12px; }

._publishPipeline_y2fo8_7 ._devUI_y2fo8_25 ._text_y2fo8_25 {
  margin-bottom: 42px; }

._publishPipeline_y2fo8_7 ._devUI_y2fo8_25 ._controls_y2fo8_28 {
  display: flex;
  margin-bottom: 30px; }
  ._publishPipeline_y2fo8_7 ._devUI_y2fo8_25 ._controls_y2fo8_28 ._checkboxWrapper_y2fo8_31 {
    width: 346px;
    align-self: center; }
    ._publishPipeline_y2fo8_7 ._devUI_y2fo8_25 ._controls_y2fo8_28 ._checkboxWrapper_y2fo8_31 svg:not(:root) {
      overflow: visible; }
  ._publishPipeline_y2fo8_7 ._devUI_y2fo8_25 ._controls_y2fo8_28 ._buttons_y2fo8_36 {
    display: flex;
    gap: 10px;
    justify-content: space-between; }

._publishPipeline_y2fo8_7 ._devUI_y2fo8_25 ._footerLink_y2fo8_41 ._divider_y2fo8_41 {
  margin: 0 -30px 10px; }

._publishPipeline_y2fo8_7 ._devUI_y2fo8_25 ._footerLink_y2fo8_41 ._link_y2fo8_44 {
  display: flex;
  justify-content: center; }

._publishPipeline_y2fo8_7 .control-base-modal-footer {
  align-items: center; }

._publishPipeline_y2fo8_7 .control-message-modal.control-message-modal.with-illustration,
._publishPipeline_y2fo8_7 .control-custom-modal.control-custom-modal {
  width: 600px; }
